import React from 'react';
import { FeatureItem, Section, SectionHeader, useScrollReveal } from '../ui';
import { comparisonRowsData } from './problem-solution.data';

const ArrowConnector = () => (
  <div className="flex items-center justify-center w-full h-full px-2 py-4 md:py-0">
    <svg
      width="44"
      height="44"
      viewBox="0 0 24 24"
      className="rotate-90 md:rotate-0 transition-transform drop-shadow-sm fill-tertiary stroke-tertiary stroke-[1.5px] hover:scale-110 duration-300"
    >
      <path d="M22 12L12 2v6H2v8h10v6z" />
    </svg>
  </div>
);

const commonIconProps = {
  removeIconBackground: true,
  iconSize: 'w-16 h-16 md:w-20 md:h-20 shrink-0',
};

const sectionTitle = (
  <>
    The Problem & <span className="text-tertiary">Our Solution</span>
  </>
);

function ProblemIcon({ src, alt }: { src: string; alt: string }) {
  return (
    <img
      src={src}
      alt={alt}
      width={256}
      height={256}
      className="w-full h-full p-1 object-contain"
      loading="lazy"
    />
  );
}

// eslint-disable-next-line import/prefer-default-export
export function ProblemSolution() {
  const revealRef = useScrollReveal();
  return (
    <Section variant="default" className="pb-20">
      <div className="max-w-5xl mx-auto px-4 text-left">
        <SectionHeader
          title={sectionTitle}
          subtitle="See how BoostHiring transforms every hiring pain point into a streamlined advantage."
          subtitleTag="h3"
        />
        <div
          ref={revealRef}
          className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] md:gap-x-0 lg:gap-x-0 gap-y-6 items-stretch"
        >
          {comparisonRowsData.map((row, i) => (
            <React.Fragment key={row.problem.title}>
              <div
                className="scroll-reveal px-0 md:px-4 lg:px-6 w-full h-full grid items-stretch"
                style={{ '--reveal-index': i } as React.CSSProperties}
              >
                <FeatureItem
                  isCard
                  variant="problem"
                  icon={<ProblemIcon src={row.problem.iconSrc} alt={row.problem.iconAlt} />}
                  title={row.problem.title}
                  description={row.problem.description}
                  {...commonIconProps}
                />
              </div>
              <div
                className="scroll-reveal flex items-center justify-center self-stretch py-2 md:py-0"
                style={{ '--reveal-index': i } as React.CSSProperties}
              >
                <ArrowConnector />
              </div>
              <div
                className="scroll-reveal px-0 md:px-4 lg:px-6 w-full h-full grid items-stretch"
                style={{ '--reveal-index': i } as React.CSSProperties}
              >
                <FeatureItem
                  isCard
                  variant="solution"
                  icon={<ProblemIcon src={row.solution.iconSrc} alt={row.solution.iconAlt} />}
                  title={row.solution.title}
                  description={row.solution.description}
                  {...commonIconProps}
                />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </Section>
  );
}
